import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for deleting a subscription block.
 *
 * @param port - Subscription block API port
 * @returns Use case executor
 */
export const deleteSubscriptionBlockUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (blockUuid: string): Promise<void> => {
    try {
      await port.delete(blockUuid);
      subLog.info('deleteSubscriptionBlock', { 'block.uuid': blockUuid });
    } catch (error) {
      subLog.error('deleteSubscriptionBlock', {
        ...extractErrorAttributes(error),
        'block.uuid': blockUuid,
      });
      throw error;
    }
  };

  return { execute };
};
